const REVOKE_AFTER_MS = 10_000

export const saveFile = (blob: Blob, filename: string): void => {
  const href = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = href
  link.download = filename
  link.hidden = true
  document.body.append(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(href), REVOKE_AFTER_MS)
}
